module.exports = __webpack_public_path__ + "static/financesBudgetBrusselsLogo-nl-d20dbad4c6631cce1b96f82f1a191c6a.svg";